export const fileInput = {
  chooseFile: 'Datei aussuchen',
}
